import * as React from 'react';
import { SVGProps } from 'react';

const IconDocDeleteSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.56 4.354a1.5 1.5 0 0 1 .44 1.06V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h5.586a1.5 1.5 0 0 1 1.06.44l3.915 3.914zM9.5 5h3.293L9 1.207V4.5a.5.5 0 0 0 .5.5zm1.656 7.863L9.5 11.207l-1.635 1.635-.707-.707L8.793 10.5 7.137 8.844l.707-.707L9.5 9.793l1.635-1.635.707.707-1.635 1.635 1.656 1.656-.707.707z"
    />
  </svg>
);
export default IconDocDeleteSizeS;
